var {
  fetchNotifications,
  set_notifications_feed,
  set_notifications_feed_loading,
  notifications_feed_fail,
} = require('@actions/notificationsFeedActions');
var userActions = require('@actions/userActions');
var { getMappedNotifications } = require('./notificationsListCache');

var RETENTION_MAX_ITEMS = 500;
var RETENTION_MAX_AGE_SECONDS = 6 * 30 * 24 * 60 * 60;

function makeNotificationId(notification, disambiguationIndex) {
  var sensorKey = notification.sensor_name ? notification.sensor_name : 'field';
  var typeKey =
    (notification.notification_text &&
      (notification.notification_text.name ||
        notification.notification_text.type)) ||
    '';
  var base =
    notification.field_id +
    '#' +
    sensorKey +
    '#' +
    notification.date +
    '#' +
    typeKey;
  if (disambiguationIndex > 0) {
    base += '#' + disambiguationIndex;
  }
  return base;
}

function makeNotificationSignature(notification) {
  var text = notification.notification_text || {};
  var valueKey = text.name || text.type || '';
  return (
    valueKey +
    '|' +
    (notification.field_name || '') +
    '|' +
    (notification.sensor_name || '') +
    '|' +
    (notification.farming_unit_name || '')
  );
}

function enrichNotificationItem(notification, disambiguationIndex) {
  var item = Object.assign({}, notification);
  item.id = makeNotificationId(item, disambiguationIndex || 0);
  item.signature = makeNotificationSignature(item);
  return item;
}

function applyRetentionCap(items) {
  if (!items || items.length === 0) return [];
  var now = Math.floor(Date.now() / 1000);
  var minAllowedDate = now - RETENTION_MAX_AGE_SECONDS;
  var filtered = items.filter(function (item) {
    return item.date >= minAllowedDate;
  });
  if (filtered.length > RETENTION_MAX_ITEMS) {
    filtered = filtered.slice(0, RETENTION_MAX_ITEMS);
  }
  return filtered;
}

function flattenNotificationsFromApi(notificationsData) {
  var mapped = getMappedNotifications(notificationsData);
  var idCounts = {};
  var items = (mapped.allNotifications || []).map(function (notification) {
    var provisionalId = makeNotificationId(notification, 0);
    var count = idCounts[provisionalId] || 0;
    idCounts[provisionalId] = count + 1;
    return enrichNotificationItem(notification, count);
  });
  return applyRetentionCap(
    items.slice().sort(function (a, b) {
      return b.date - a.date;
    }),
  );
}

export function loadNotificationsInitial() {
  return function (dispatch) {
    dispatch(set_notifications_feed_loading('initial', true));
    return fetchNotifications()
      .then(function (data) {
        var items = flattenNotificationsFromApi(data);
        dispatch(
          set_notifications_feed({
            items: items,
            lastSyncAt: Math.floor(Date.now() / 1000),
          }),
        );
        // Keep the legacy user_notifications slice in sync, mirroring mobile's
        // notificationsFeedThunks. The Farm view (IrrigationSystemMonitoring)
        // reads it to render per-field alert icons, and it has no other writer
        // on web — without this the icon never appears for any alert type.
        dispatch(userActions.get_user_notifications_success(data));
        dispatch(set_notifications_feed_loading('initial', false));
      })
      .catch(function (err) {
        console.log('loadNotificationsInitial failed', err);
        dispatch(notifications_feed_fail(err));
        dispatch(set_notifications_feed_loading('initial', false));
      });
  };
}

export function syncNotificationsFeed() {
  return function (dispatch) {
    dispatch(set_notifications_feed_loading('sync', true));
    return fetchNotifications()
      .then(function (data) {
        var items = flattenNotificationsFromApi(data);
        dispatch(
          set_notifications_feed({
            items: items,
            lastSyncAt: Math.floor(Date.now() / 1000),
          }),
        );
        dispatch(userActions.get_user_notifications_success(data));
        dispatch(set_notifications_feed_loading('sync', false));
      })
      .catch(function (err) {
        console.log('syncNotificationsFeed failed', err);
        dispatch(set_notifications_feed_loading('sync', false));
      });
  };
}
